import React from 'react'
import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin } from 'lucide-react'

function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-3">
              <img 
                src="https://callmedilife-mail-images.s3.ap-south-1.amazonaws.com/cml-logo-new.png"
                alt="FaceScan AI Logo"
                className="w-[10rem] h-[3rem] bg-white rounded-lg p-1"
              />
            </div>
            <p className="text-gray-400 mb-3 max-w-md text-sm">
              Advanced AI-powered health analysis from face scans. Get comprehensive 
              insights into your wellness across 13 major health categories.
            </p>
            {/* <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Phone className="w-5 h-5" />
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/scan" className="text-gray-400 hover:text-white transition-colors">
                  Start Scan
                </Link>
              </li>
              <li>
                <Link to="/history" className="text-gray-400 hover:text-white transition-colors">
                  Scan History
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Support
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-center">
                <Mail className="w-4 h-4 mr-2" />
                <span>customerservice@callmedilife.com</span>
              </div>
              <div className="flex items-center">
                <Phone className="w-4 h-4 mr-2" />
                <span>1800 266 3227</span>
              </div>
              <div className="flex items-start">
                <MapPin className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm leading-relaxed">Unit No. 303 - 304, 3rd floor, Jay Antariksh, Thakur House, Makwana Road, Marol Andheri East, Mumbai, Maharashtra 400059</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 FaceScan AI. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="https://callmedilife.com/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="https://callmedilife.com/terms-and-conditions" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              {/* <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Medical Disclaimer
              </a> */}
            </div>
          </div>
        </div>

        {/* Medical Disclaimer */}
        <div className="border-t border-gray-800 mt-6 pt-6">
          <div className="bg-red-900/20 border border-red-800/30 rounded-lg p-4">
            <h4 className="text-red-400 font-semibold mb-2">Important Medical Disclaimer</h4>
            <p className="text-red-300 text-sm leading-relaxed">
              FaceScan AI is NOT a medical device or diagnostic tool. All health measurements 
              are estimates for wellness and informational purposes only. Results should not 
              replace professional medical advice, diagnosis, or treatment. Always consult 
              healthcare professionals for any health concerns.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
